"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditSite = void 0;
const asset_list_1 = require("client/components/asset-list");
const asset_list_overview_1 = require("client/components/asset-list-overview");
const checkbox_group_1 = require("client/components/checkbox-group");
const checkbox_item_1 = require("client/components/checkbox-group/checkbox-item");
const confirmation_modal_1 = require("client/components/confirmation-modal");
const supporting_document_modal_1 = require("./components/supporting-document-modal");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const switch_1 = require("client/components/material/switch");
const text_area_1 = require("client/components/material/text-area");
const text_field_1 = require("client/components/material/text-field");
const modal_1 = require("client/components/modal");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const upload_modal_1 = require("client/components/upload-modal");
const store_1 = require("client/modules/app-settings/store");
const iframe_preview_1 = require("client/modules/inventory-order/tabs/order-review/components/iframe-preview");
const store_2 = require("client/modules/patients/store");
const store_3 = require("client/modules/sites/modules/sites-detail/store");
const store_4 = require("client/modules/store");
const store_5 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react"); //
const moment = require("moment-timezone");
const ramda_1 = require("ramda");
const React = require("react");
const app_settings_1 = require("shared/app-settings");
const DeleteForever_1 = require("@material-ui/icons/DeleteForever");
const Edit_1 = require("@material-ui/icons/Edit");
const permissions_1 = require("shared/permissions");
const site_1 = require("shared/site");
const clinic_hours_1 = require("./components/clinic-hours");
require("./edit-site.less");
const ReactTooltip = require("react-tooltip");
const table_1 = require("client/components/material/table");
const material_ui_1 = require("material-ui");
const material_ui_icons_1 = require("material-ui-icons");
const validClinicUserEditFieldGroup = {
    address: site_1.FieldGroup.Location,
    city: site_1.FieldGroup.Location,
    fax: site_1.FieldGroup.Authorized,
    hours: site_1.FieldGroup.Authorized,
    name: site_1.FieldGroup.Name,
    ncpdpId: site_1.FieldGroup.NCPDP,
    npiNumber: site_1.FieldGroup.NPI,
    phone: site_1.FieldGroup.Authorized,
    phoneExt: site_1.FieldGroup.Authorized,
    state: site_1.FieldGroup.Location,
    taxId: site_1.FieldGroup.TaxId,
    zip: site_1.FieldGroup.Location
};
const checkboxGroupData = [
    { id: 0, label: "live" },
    { id: 1, label: "disabled" }
];
const insuranceRelationshipOptions = [
    {
        id: 0,
        label: "Not Specified",
        value: "0"
    },
    {
        id: 1,
        label: "Cardholder",
        value: "1"
    },
    {
        id: 2,
        label: "Spouse",
        value: "2"
    },
    {
        id: 3,
        label: "Child",
        value: "3"
    },
    {
        id: 4,
        label: "Other",
        value: "4"
    }
];
const dummyClinicHours = {
    friday: {
        hours: [
            {
                from: "9am",
                to: "5pm"
            }
        ],
        open: true,
        split: false
    },
    monday: {
        hours: [
            {
                from: "9am",
                to: "5pm"
            }
        ],
        open: true,
        split: false
    },
    saturday: {
        hours: [
            {
                from: "9am",
                to: "5pm"
            }
        ],
        open: true,
        split: false
    },
    sunday: {
        hours: [
            {
                from: "9am",
                to: "5pm"
            }
        ],
        open: true,
        split: false
    },
    thursday: {
        hours: [
            {
                from: "9am",
                to: "5pm"
            }
        ],
        open: true,
        split: false
    },
    tuesday: {
        hours: [
            {
                from: "9am",
                to: "5pm"
            }
        ],
        open: true,
        split: false
    },
    wednesday: {
        hours: [
            {
                from: "9am",
                to: "5pm"
            }
        ],
        open: true,
        split: false
    }
};
const dummySite = {
    address: "",
    city: "",
    dba: "",
    deaLicense: "",
    displayName: "",
    fax: "",
    feeType: site_1.FeeType.Percent,
    id: 0,
    imbFee: 20,
    live: true,
    maxCopay: 0,
    minProfit: 0,
    name: "",
    ncpdpId: "",
    notes: "",
    npiNumber: "",
    phone: "",
    phoneExt: "",
    picProviderId: 0,
    startBalance: 0,
    state: "",
    taxId: "",
    timezone: moment.tz.guess(),
    transactionFee: 0,
    typeDAW: 0,
    uploads: [],
    website: "",
    zip: ""
};
const dummyInsurance = {
    benefitEffectiveDate: null,
    benefitIneffectiveDate: null,
    binNum: "",
    cardholderFirst: "",
    cardholderLast: "",
    copay: true,
    insuranceId: "",
    insuranceRelationship: 0,
    inventoryId: null,
    payerCoverageType: "",
    payerGroupId: "",
    payerIdCount: "",
    payerIdQualifier: "",
    payerPersonCode: "",
    payerPhone: "",
    pcn: "",
    primaryCopay: false,
    primaryInsurance: false,
    site: 0
};
// const highLevelTitles = ["DO", "MD"];
const typeDAWStr = [
    "0 - No Product Selection Indicated",
    "1 - Substitution Not Allowed by Prescriber",
    "2 - Substitution Allowed - Patient Requested Product Dispensed",
    "3 - Substitution Allowed - Pharmacist Selected Product Dispensed",
    "4 - Substitution Allowed - Generic Drug Not in Stock",
    "5 - Substitution Allowed - Brand Drug Dispensed as Generic",
    "6 - Override",
    "7 - Substitution Not Allowed - Brand Drug Mandated by Law",
    "8 - Substitution Allowed - Generic Drug Not Available in Marketplace",
    "9 - Other/Substitution Allowed - Plan Requests Brand Dispensed"
];
const statesStr = [
    "AK",
    "AL",
    "AR",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY"
];
const states = statesStr.sort().map((state, i) => ({
    id: i,
    label: state,
    value: state
}));
const typeDAW = typeDAWStr.map((daw, i) => ({
    id: i,
    label: daw,
    value: daw.substr(0, 1)
}));
const usTimezones = {
    "America/Anchorage": "Alaska Time Zone",
    "America/Chicago": "Central Time Zone",
    "America/Denver": "Mountain Time Zone",
    "America/Los_Angeles": "Pacific Time Zone",
    "America/New_York": "Eastern Time Zone",
    "Pacific/Honolulu": "Hawaii Time Zone"
};
const timezones = moment.tz
    .names()
    .filter((zone) => usTimezones[zone])
    .map((zone, i) => ({
    id: i,
    label: usTimezones[zone],
    value: zone
}))
    .sort((a, b) => (a.label > b.label ? 1 : -1));
let EditSite = class EditSite extends React.Component {
    constructor(props) {
        super(props);
        // E-044
        this.permissions = [];
        this.loadAll = async () => {
            this.permissions = await store_5.usersStore.loadAllPermissions();
        };
        this.checkboxSelections = {
            archived: false,
            disabled: false,
            live: false
        };
        this.assetModal = false;
        this.copays = [];
        this.confirmDeleteInsuranceModal = false;
        this.clinicHoursHasChanged = false;
        this.disableSave = false; // #TK added
        this.editInsurance = false;
        this.enrollment = true;
        this.highLevelTitles = [];
        this.iframeUrl = "";
        this.insurance = dummyInsurance;
        this.justSaved = false; // #TK added
        this.showSupportingDocumentModal = false;
        this.supportingDocumentGroupName = "";
        this.uploadModal = false;
        this.uploadSupportingDocumentModal = false;
        this.supportingDocumentGroup = {
            [site_1.FieldGroup.Location]: [],
            [site_1.FieldGroup.Name]: [],
            [site_1.FieldGroup.NPI]: [],
            [site_1.FieldGroup.NCPDP]: [],
            [site_1.FieldGroup.TaxId]: []
        };
        // E-044
        this.handleClick = (e) => {
            this.setState({ anchorEl: e.currentTarget });
        };
        // E-044
        this.handleClose = () => {
            this.setState({ anchorEl: null });
        };
        this.handleEditDetails = () => {
            this.setState({ modelOpen: true });
            this.setState({ anchorEl: null });
        };
        this.disableEditDetails = () => {
            this.setState({ modelOpen: false });
            this.setState({ anchorEl: null });
        };
        this.isAddPharmacy = ""; //E-044
        this.openInsuranceEditModal = (insurance) => {
            if (!!insurance)
                this.insurance = insurance;
            this.editInsurance = true;
        };
        this.handleDeleteInsurance = async () => {
            const insuranceId = this.insurance.id;
            this.confirmDeleteInsuranceModal = false;
            const result = await store_3.sitesDetailStore.deleteCopay(insuranceId);
            this.copays = await store_3.sitesDetailStore.readCopays(this.site.id);
            this.insurance = dummyInsurance;
        };
        this.onHandleClickCheckboxItem = (item) => {
            this.site.live = item.label === "live";
            this.checkboxSelections.live = this.site.live;
            this.checkboxSelections.disabled = !this.site.live;
        };
        this.handleChangeInsurance = (fieldName) => (event, value) => {
            this.insurance[fieldName] = value;
        };
        this.handleInsuranceRelationship = (fieldName) => (value) => {
            this.insurance.insuranceRelationship = parseInt(value, 10);
        };
        this.handleSubmitInsurance = async () => {
            this.insurance.siteId = this.site.id;
            await store_3.sitesDetailStore.saveCopay(this.insurance);
            this.editInsurance = false;
            this.insurance = dummyInsurance;
            this.copays = await store_3.sitesDetailStore.readCopays(this.site.id);
        };
        this.editInsuranceModal = () => {
            var _a;
            const newInsurance = !((_a = this.insurance) === null || _a === void 0 ? void 0 : _a.id);
            const fields = () => {
                var _a, _b, _c, _d;
                return (React.createElement("div", { className: "insurance-edit" },
                    React.createElement("div", { className: "row" },
                        React.createElement(text_field_1.MaterialTextField, { label: "Insurance ID", onChange: this.handleChangeInsurance("insuranceId"), value: (_a = this.insurance.insuranceId) !== null && _a !== void 0 ? _a : "" }),
                        React.createElement(text_field_1.MaterialTextField, { label: "Group ID", onChange: this.handleChangeInsurance("payerGroupId"), value: (_b = this.insurance.payerGroupId) !== null && _b !== void 0 ? _b : "" })),
                    React.createElement("div", { className: "row" },
                        React.createElement(text_field_1.MaterialTextField, { label: "BIN", onChange: this.handleChangeInsurance("binNum"), value: (_c = this.insurance.binNum) !== null && _c !== void 0 ? _c : "" }),
                        React.createElement(text_field_1.MaterialTextField, { label: "PCN", onChange: this.handleChangeInsurance("pcn"), value: (_d = this.insurance.pcn) !== null && _d !== void 0 ? _d : "" }))));
            };
            const modalButtons = [
                React.createElement(button_1.MaterialButton, { onClick: () => {
                        this.insurance = dummyInsurance;
                        this.editInsurance = false;
                    } }, "Go Back"),
                React.createElement(button_1.MaterialButton, { onClick: async () => this.handleSubmitInsurance(), primary: true, style: { marginLeft: "1em" } }, "Confirm Copay")
            ];
            const modal = (React.createElement(modal_1.Modal, { buttons: modalButtons, height: "60%", onCancel: () => {
                    this.editInsurance = false;
                }, top: "20%", width: "40%" },
                React.createElement("div", { style: {
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-around"
                    } },
                    React.createElement("b", { style: { fontSize: "1.5em" } },
                        newInsurance ? "New" : "Edit",
                        " Copay")),
                React.createElement(select_1.MaterialSelect, { className: "insurance-full-width", label: "Associated Medication", 
                    // onSearch={e =>
                    //   (this.availableInventoryOptions = this.handleSearch(e))
                    // }
                    onSelect: value => (this.insurance.inventoryId = value), options: [
                        // {
                        //   id: 0,
                        //   label: "Use All Medications",
                        //   value: null
                        // },
                        ...this.availableInventory
                    ], searchable: true, value: String(this.insurance.inventoryId) }),
                fields(),
                React.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "space-around",
                        marginTop: "2em",
                        width: "100%"
                    } })));
            return modal;
        };
        // endregion
        this.renderSiteAssetListRow = () => this.site.uploads && this.site.uploads.length
            ? this.site.uploads
                .sort((a, b) => moment(a.expDate) < moment(b.expDate) ? 1 : -1)
                .map((upload, index) => {
                let expdate = "";
                if (upload.expDate) {
                    expdate = moment(upload.expDate).format("MM/DD/YYYY");
                }
                return (React.createElement("li", { "data-tip": `${upload.fileOriginalName} ${upload.description ? ` (${upload.description})` : ""}
                    `, onClick: () => {
                        this.iframeUrl = upload.filePath;
                        this.currentAssetViewing = upload;
                    }, key: index, className: "list" },
                    React.createElement("div", { className: "list-expdate__name" }, upload.description || upload.fileOriginalName),
                    React.createElement("div", { className: "list-expdate__date" }, expdate ? ` ${expdate}` : "")));
            })
            : null;
        this.getWebsiteUrl = () => {
            if (this.siteWebsiteUrl) {
                const { hostname, pathname } = this.siteWebsiteUrl;
                return `${hostname}${pathname.length > 1 ? pathname : ""}`;
            }
            return this.site.website;
        };
        this.renderInsurance = () => {
            var _a;
            const copayCards = (_a = this.copays) !== null && _a !== void 0 ? _a : [];
            const columns = ["Package", "ID", "BIN", "PCN", "Edit"].map((label) => ({
                id: `ins.${label
                    .toLowerCase()
                    .split(" ")
                    .join("")}`,
                label
            }));
            const renderRow = (row) => {
                var _a, _b, _c;
                const inventory = (_c = (_b = (_a = store_3.sitesDetailStore.inventorysites) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.find(ndc => ndc.inventoryId === row.inventoryId)) === null || _c === void 0 ? void 0 : _c.inventory;
                return (React.createElement(table_1.MaterialTableRow, { key: row.insuranceId },
                    React.createElement(table_1.MaterialTableCell, { center: true },
                        React.createElement("div", { className: "ins__cell", style: { overflow: "visible", whiteSpace: "nowrap" } }, inventory === null || inventory === void 0 ? void 0 : inventory.package)),
                    React.createElement(table_1.MaterialTableCell, { center: true },
                        React.createElement("div", { className: "ins__cell", style: { whiteSpace: "nowrap" } }, row.insuranceId)),
                    React.createElement(table_1.MaterialTableCell, { center: true },
                        React.createElement("div", { className: "ins__cell", style: { whiteSpace: "nowrap" } }, row.binNum)),
                    React.createElement(table_1.MaterialTableCell, { center: true },
                        React.createElement("div", { className: "ins__cell", style: { whiteSpace: "nowrap" } }, row.pcn)),
                    React.createElement(table_1.MaterialTableCell, { center: true }, !this.state.isActiveEditForm ? (React.createElement("div", { className: "ins__cell" },
                        React.createElement(Edit_1.default, { onClick: () => {
                                this.insurance = row;
                                this.editInsurance = true;
                            } }),
                        React.createElement(DeleteForever_1.default, { onClick: () => {
                                this.insurance = row;
                                this.confirmDeleteInsuranceModal = true;
                            } }))) : null)));
            };
            return [copayCards].map((cards, i) => (React.createElement(table_1.MaterialTable, { key: `copay-cards-${i}`, rows: cards, columns: columns, order: "ASC", orderBy: "", renderRow: renderRow, style: { marginLeft: "3em" } })));
        };
        this.newInsurance = () => {
            this.insurance = dummyInsurance;
            this.editInsurance = true;
        };
        this.handleClinicHoursChange = (day, index) => (hourRange) => (event, value) => {
            this.site.clinicHours[day].hours[index][hourRange] = value;
            if (!this.clinicHoursHasChanged) {
                this.clinicHoursHasChanged = true;
                this.forceUpdate();
            }
        };
        this.handleClinicHoursToggle = (day) => (field) => () => {
            this.site.clinicHours[day][field] = !this.site.clinicHours[day][field];
            if (field === "split") {
                if (this.site.clinicHours[day][field]) {
                    this.site.clinicHours[day].hours[1] = { from: "1pm", to: "7pm" };
                }
                else {
                    this.site.clinicHours[day].hours.pop();
                }
            }
            if (!this.clinicHoursHasChanged) {
                this.clinicHoursHasChanged = true;
                this.forceUpdate();
            }
        };
        // eslint-disable-next-line @typescript-eslint/member-ordering
        this.handleSubmitClinicUserUpdateRequest = async () => {
            const fromTos = this.getFromTos();
            const fromToGroups = ramda_1.groupBy(ft => ft[1].group, fromTos);
            const haveMatchingAttachments = Object.entries(fromToGroups)
                .filter(([groupName]) => groupName !== site_1.FieldGroup.Authorized)
                .every(ftg => {
                const [groupName] = ftg;
                return (this.supportingDocumentGroup[groupName] &&
                    this.supportingDocumentGroup[groupName].length);
            });
            const attachedDocumentsGroup = Object.entries(this.supportingDocumentGroup).filter(([key, sdg]) => key !== site_1.FieldGroup.Authorized && sdg.length);
            if (haveMatchingAttachments) {
                // save request
                console.info("have all matching attachment :)");
                // save fromTos to siteUpdateMeta column in upload table.
                // submit info change request with supporting documents.
                // group attaching documents to fields being changed
                // create new upload with changed fields meta data.
                try {
                    for (const group of attachedDocumentsGroup) {
                        const [groupName, attachedDocuments] = group;
                        const siteUpdateMetas = fromToGroups[groupName];
                        const uploadMeta = {
                            groupName,
                            siteUpdateMetas,
                            supportingDocuments: attachedDocuments
                        };
                        const siteId = this.site.id;
                        await store_3.sitesDetailStore.createUserSiteUpdateRequest(uploadMeta, siteId);
                    }
                }
                catch (err) {
                    console.error("Error caught while creating user site update request");
                }
                // save authorized fields
                const siteAuthorizedUpdate = {};
                const { Authorized } = fromToGroups;
                if (Authorized === null || Authorized === void 0 ? void 0 : Authorized.length) {
                    for (const entry of Authorized) {
                        const [key, fromToMeta] = entry;
                        siteAuthorizedUpdate[key] = fromToMeta.to;
                    }
                }
                const siteWithAuthorizedUpdate = Object.assign(Object.assign(Object.assign({}, this.props.site), siteAuthorizedUpdate), { clinicHours: this.site.clinicHours });
                callable_1.callable(this.props.onSave)(siteWithAuthorizedUpdate, this.enrollment);
                this.showSupportingDocumentModal = false;
                this.clinicHoursHasChanged = false;
            }
            else {
                alert("All changed fields need attaching supporting documents.");
            }
        };
        this.handleAttachDoc = (groupName) => () => {
            console.info("groupName is ", groupName);
            this.supportingDocumentGroupName = groupName;
            this.uploadSupportingDocumentModal = true;
        };
        this.getFromTos = () => {
            const result = ramda_1.difference(Object.entries(this.site), Object.entries(ramda_1.merge(dummySite, this.props.site)));
            const result2 = ramda_1.difference(Object.entries(ramda_1.merge(dummySite, this.props.site)), Object.entries(this.site));
            const fromTos = result2
                .filter(([key]) => validClinicUserEditFieldGroup[key])
                .map(data => {
                const [key, value] = data;
                const fromValue = value;
                const toResult = result.find(keyval => keyval[0] === key);
                const toValue = toResult ? toResult[1] : null;
                return [
                    key,
                    {
                        from: fromValue,
                        group: validClinicUserEditFieldGroup[key],
                        to: toValue
                    }
                ];
            });
            return fromTos;
        };
        this.toggleEnrollment = () => {
            this.enrollment = !this.enrollment;
        };
        this.renderCheckboxItem = (item) => (React.createElement(checkbox_item_1.CheckboxItem, { checked: this.checkboxSelections[item.label], key: item.id, item: item, onHandleClick: this.onHandleClickCheckboxItem }));
        this.renderCheckboxGroup = () => (React.createElement(checkbox_group_1.CheckboxGroup, { data: checkboxGroupData, renderItem: this.renderCheckboxItem, value: this.site.live }));
        this.handlePreviewClose = () => {
            this.iframeUrl = "";
            this.currentAssetViewing = null;
        };
        this.handleAssetsDescriptionsSave = async (uploads) => {
            await store_2.patientsStore.updateAssetsDescriptions(uploads);
            await store_3.sitesDetailStore.readSite(this.site.id);
        };
        this.handleAssetsUpload = async (accepted) => {
            await store_3.sitesDetailStore.upload(accepted, String(this.site.id), this.uploadType, "Site");
            await store_3.sitesDetailStore.readSite(this.site.id);
            router_1.RouteManager.transitionTo(`/pharmacies/${this.site.id}`);
        };
        this.handleSupportingDocumentUpload = async (accepted) => {
            console.info("handleSupportingDocumentUpload triggered accepted is ", accepted);
            this.supportingDocumentGroup[this.supportingDocumentGroupName]
                ? this.supportingDocumentGroup[this.supportingDocumentGroupName].push(...accepted)
                : [accepted];
        };
        this.resetSupportingDocumentGroup = () => {
            this.supportingDocumentGroupName = "";
            this.supportingDocumentGroup = {
                [site_1.FieldGroup.Location]: [],
                [site_1.FieldGroup.Name]: [],
                [site_1.FieldGroup.NPI]: [],
                [site_1.FieldGroup.NCPDP]: [],
                [site_1.FieldGroup.TaxId]: []
            };
        };
        this.handleAssetsExpDateSave = async (uploads) => {
            await store_2.patientsStore.updateAssetsExpDate(uploads);
            // patientsStore.loadPatients();
            await store_3.sitesDetailStore.readSite(this.site.id);
        };
        // endregion
        // region Event handlers
        this.handleChangeState = (value) => {
            this.site.state = value;
        };
        this.handleTaxIdChange = (e) => {
            const regex = /^[0-9\b]+$/;
            if (e.target.value === "" || regex.test(e.target.value)) {
                this.site.taxId = e.target.value;
            }
        };
        this.handleChangeTypeDAW = (value) => {
            this.site.typeDAW = Number(value);
        };
        this.handleChangeFeeType = (value) => {
            this.site.feeType = value;
            if (this.site.id === 0) {
                if (value === site_1.FeeType.FlatRate) {
                    this.site.imbFee = 5;
                }
                else {
                    this.site.imbFee = 20;
                }
            }
        };
        this.handleChangePIC = (value) => {
            this.site.picProviderId = Number(value);
        };
        this.handleChangeTimezone = (value) => {
            this.site.timezone = value;
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            const regex = /^$|^\S+.*/;
            if (value === "" || regex.test(value)) {
                if (fieldName === "zip") {
                    const foundState = store_4.generalStore.getState(value);
                    if (foundState !== "none") {
                        this.site.state = foundState;
                    }
                }
                const re = /^https?:\/\//;
                if (fieldName === "website") {
                    try {
                        const isValidUrl = re.test(value); /* ? */
                        if (isValidUrl) {
                            this.siteWebsiteUrl = new URL(value);
                        }
                        else {
                            this.siteWebsiteUrl = new URL(`http://${value}`);
                        }
                    }
                    catch (err) {
                        this.siteWebsiteUrl = null;
                    }
                }
                if (fieldName === "website") {
                    this.site[fieldName] = value.replace(re, "");
                }
                else {
                    this.site[fieldName] = value;
                }
            }
            // #TK added: any empty/invalid fields will disable the save button.
            if (!this.isValid(this.site)) {
                this.disableSave = true;
            }
            else {
                this.disableSave = false;
            }
        };
        this.handleChangeNumber = (fieldName) => (event, value) => {
            if (!Number.isNaN(Number(value)))
                this.site[fieldName] = value;
            // #TK added: any empty/invalid fields will disable the save button.
            if (!this.isValid(this.site)) {
                this.disableSave = true;
            }
            else {
                this.disableSave = false;
            }
            // console.log(this.disableSave);
        };
        this.isChanged = () => {
            const result = ramda_1.difference(Object.entries(this.site), Object.entries(ramda_1.merge(dummySite, this.props.site)));
            return result.length > 0 || this.clinicHoursHasChanged;
        };
        this.isValid = (site) => Boolean(site.name &&
            site.displayName &&
            site.address &&
            site.city &&
            site.state &&
            site.zip &&
            site.phone &&
            site.timezone &&
            // site.deaLicense &&
            site.ncpdpId &&
            site.npiNumber &&
            site.taxId);
        /**
         * Save pharmacy form with mail send
         */
        this.handleSubmit = () => {
            this.justSaved = true; // #TK added
            if (!this.isValid(this.site)) {
                this.missing = {
                    address: !this.site.address,
                    city: !this.site.city,
                    deaLicense: false,
                    displayName: !this.site.displayName,
                    feeType: !this.site.feeType,
                    imbFee: !this.site.imbFee,
                    maxCopay: !this.site.maxCopay,
                    minProfit: !this.site.minProfit,
                    name: !this.site.name,
                    ncpdpId: !this.site.ncpdpId,
                    npiNumber: !this.site.npiNumber,
                    phone: !this.site.phone,
                    state: !this.site.state,
                    taxId: !this.site.taxId,
                    // deaLicense: !this.site.deaLicense,
                    timezone: !this.site.timezone,
                    transactionFee: !this.site.feeType,
                    typeDAW: !this.site.typeDAW,
                    zip: !this.site.zip
                };
            }
            else {
                this.missing = {
                    address: false,
                    city: false,
                    deaLicense: false,
                    displayName: false,
                    feeType: false,
                    imbFee: false,
                    maxCopay: false,
                    minProfit: false,
                    name: false,
                    ncpdpId: false,
                    npiNumber: false,
                    phone: false,
                    state: false,
                    taxId: false,
                    timezone: false,
                    transactionFee: false,
                    typeDAW: false,
                    zip: false
                };
                // this.site.clinicHours = merge(this.site.clinicHours, this.clinicHours);
                this.site.minProfit = Number(this.site.minProfit); // Convert blank to 0.
                callable_1.callable(this.props.onSave)(this.site, this.enrollment);
                this.showSupportingDocumentModal = false;
                this.clinicHoursHasChanged = false;
            }
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
        // E-044
        this.handleEditUser = () => {
            this.setState({ modelOpen: false });
            this.setState({ isActiveEditForm: false });
        };
        this.disableEditUserForm = () => {
            this.setState({ isActiveEditForm: true });
        };
        this.handleDelete = () => {
            callable_1.callable(this.props.onDelete)(this.site);
        };
        this.handleClickCancelUpload = () => {
            this.uploadModal = false;
        };
        this.viewPatientAssets = () => {
            this.assetModal = !this.assetModal;
        };
        this.onCredentialUpload = () => {
            this.uploadType = "credential";
            this.uploadModal = true;
        };
        this.onImageUpload = () => {
            this.uploadType = "image";
            this.uploadModal = true;
        };
        this.onDeleteAsset = async (uploadId) => {
            await store_3.sitesDetailStore.deleteUpload(uploadId);
            await store_3.sitesDetailStore.readSite(this.site.id);
        };
        this.viewSiteAssets = () => {
            this.setState({ anchorEl: null }); //E-044
            this.assetModal = !this.assetModal;
        };
        this.state = {
            anchorEl: null,
            diloagOpen: false,
            modelOpen: false,
            isActiveEditForm: true //E-044
        };
    }
    get picOptions() {
        return this.props.site &&
            this.props.site.id &&
            store_3.sitesDetailStore.providers.value
            ? store_3.sitesDetailStore.providers.value
                .filter(provider => this.highLevelTitles.includes(provider.title))
                .map((provider, i) => ({
                id: i,
                label: `${provider.prefix} ${provider.firstName} ${provider.lastName} ${provider.suffix}`,
                value: provider.id.toString()
            }))
            : [];
    }
    // region React
    UNSAFE_componentWillMount() {
        this.site = ramda_1.merge(dummySite, this.props.site);
        this.checkboxSelections.live = this.site.live;
        this.checkboxSelections.disabled = !this.site.live;
        if (this.site.timezone === "")
            this.site.timezone = moment.tz.guess();
        this.missing = {
            address: false,
            city: false,
            deaLicense: false,
            displayName: false,
            feeType: false,
            imbFee: false,
            maxCopay: false,
            minProfit: false,
            name: false,
            ncpdpId: false,
            npiNumber: false,
            phone: false,
            state: false,
            taxId: false,
            timezone: false,
            transactionFee: false,
            typeDAW: false,
            zip: false
        };
        if (!this.site.clinicHours) {
            this.site.clinicHours = dummyClinicHours;
        }
    }
    get availableInventory() {
        return store_3.sitesDetailStore.inventorysites.value
            ? store_3.sitesDetailStore.inventorysites.value.map((ndc, i) => ({
                daysSupply: ndc.inventory.daysSupply,
                group: ndc.inventory.inventoryGroupId,
                id: ndc.inventory.id,
                label: `${ndc.inventory.name} (${ndc.inventory.package})`,
                quantity: !!ndc.claimQuantity
                    ? ndc.claimQuantity
                    : ndc.inventory.claimQuantity,
                value: ndc.inventory.id.toString()
            }))
            : [];
    }
    async componentDidMount() {
        //E-044
        this.isAddPharmacy = window.location.href.split("/")[4];
        if (this.isAddPharmacy == 0) {
            this.setState({ isActiveEditForm: false });
        }
        ReactTooltip.rebuild();
        if (!this.site.clinicHours) {
            this.site.clinicHours = dummyClinicHours;
        }
        const highLevelTitles = await store_1.appSettingsStore.readSettings(app_settings_1.AppOption.PicAllowedTitles, true);
        this.highLevelTitles = highLevelTitles.value.split(",");
    }
    async UNSAFE_componentWillReceiveProps(props) {
        ReactTooltip.rebuild();
        if (props.site) {
            this.site = ramda_1.merge(dummySite, props.site);
            if (!this.site.clinicHours) {
                this.site.clinicHours = dummyClinicHours;
            }
            await store_3.sitesDetailStore.loadInventories(this.site.id);
            this.copays = await store_3.sitesDetailStore.readCopays(this.site.id);
        }
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    // eslint-disable-next-line @typescript-eslint/member-ordering
    render() {
        var _a, _b;
        const site = this.site || dummySite;
        const canEdit = store_5.usersStore.permissions.UpdatePharmacy;
        const isEditPharmacy = store_5.usersStore.permissions.EditPharmacies; //E-044
        // C-094.11
        let getNumber = this.site.phone.slice(0, 14); // C-094.12
        let getFaxNumber = this.site.fax.slice(0, 14); // C-094.12
        let DataVal;
        let isError;
        let DataValFax;
        let isErrorFax;
        if (getNumber.length) {
            DataVal = getNumber.replace(/\D+/g, "")
                .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
            if (DataVal) {
                if (DataVal.length != 14) {
                    isError = "The information input currently is invalid";
                }
                else {
                    isError = "";
                }
            }
        }
        if (getFaxNumber.length) {
            DataValFax = getFaxNumber.replace(/\D+/g, "")
                .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
            if (DataValFax) {
                if (DataValFax.length != 14) {
                    isErrorFax = "The information input currently is invalid";
                }
                else {
                    isErrorFax = "";
                }
            }
        }
        const warning = this.props.warning
            ? "No Physician In Charge selected for this pharmacy"
            : "";
        const userCanView = store_5.usersStore.user.value.user ||
            store_5.usersStore.user.value.group === permissions_1.GROUPS.SITE_ADMIN;
        const isClinicUser = store_5.usersStore.user.value.siteUser;
        // E-044 here from all editable
        return (React.createElement("div", { className: "edit-site" },
            React.createElement(ui_1.UiForm, { buttons: canEdit || isEditPharmacy //E-044
                    ? [
                        React.createElement(button_1.MaterialButton, { key: "delete", disabled: this.state.isActiveEditForm
                                ? this.state.isActiveEditForm
                                : !store_5.usersStore.permissions.DestroyPharmacy, className: "btnDelete", onClick: this.handleDelete, style: { whiteSpace: "nowrap" } }, "DISABLE PHARMACY  "),
                        React.createElement(button_1.MaterialButton, { key: "save", className: "btnCancel", onClick: this.handleCancel, disabled: this.state.isActiveEditForm
                                ? this.state.isActiveEditForm
                                : !isEditPharmacy },
                            this.justSaved ? "Back" : "CANCEL",
                            " "),
                        "Save"
                    ]
                    : "", loading: this.props.loading, isChanged: this.isChanged, status: this.props.status, saved: "Saved", warning: warning, onSubmit: () => {
                    if (isClinicUser) {
                        const fromTos = this.getFromTos();
                        console.info("fromTos in onsubmit", fromTos);
                        const allChangedFieldsAuthorizied = fromTos.every(([key, value]) => validClinicUserEditFieldGroup[key] === site_1.FieldGroup.Authorized);
                        if (allChangedFieldsAuthorizied) {
                            this.handleSubmit();
                        }
                        else {
                            this.showSupportingDocumentModal = true;
                        }
                    }
                    else {
                        this.handleSubmit();
                    }
                }, error: this.props.error, 
                // shouldDisableSave={this.disableSave} // #TK added
                shouldDisableSave: this.isAddPharmacy && ((isError === null || isError === void 0 ? void 0 : isError.length) > 0 || (isErrorFax === null || isErrorFax === void 0 ? void 0 : isErrorFax.length) > 0) ? true : false },
                React.createElement("div", { className: "main" },
                    React.createElement("h3", { className: "cstm-heading" }, "PHARMACY INFO"),
                    " ",
                    React.createElement("div", { className: "site-info" },
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !canEdit, autoFocus: true, label: "Legal Name *", missing: this.missing.name, onChange: this.handleChangeString("name"), value: `${site.name}` || "" })),
                        React.createElement("div", { className: "row" },
                            !isClinicUser ? (React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !canEdit, label: "Display Name *", onChange: this.handleChangeString("displayName"), value: `${site.displayName}` || "" })) : null,
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !canEdit, label: "Doing Business As", onChange: this.handleChangeString("dba"), value: `${site.dba}` || "" })),
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !canEdit, className: "address1", label: "Address 1 *", missing: this.missing.address, onChange: this.handleChangeString("address"), value: site.address || "" })),
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !canEdit, className: "city", label: "City *", missing: this.missing.city, onChange: this.handleChangeString("city"), value: site.city || "" }),
                            React.createElement("div", { className: "row" },
                                React.createElement(select_1.MaterialSelect, { disabled: this.state.isActiveEditForm
                                        ? this.state.isActiveEditForm
                                        : !canEdit, placeholder: "State", label: "State *", missing: this.missing.state, options: states, onSelect: this.handleChangeState, searchable: true, value: site.state || "" }),
                                React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm
                                        ? this.state.isActiveEditForm
                                        : !canEdit, className: "zip", label: "Zip Code *", missing: this.missing.zip, onChange: this.handleChangeString("zip"), value: site.zip || "" }))),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "select phone" },
                                React.createElement("div", { className: "phone-ext" },
                                    React.createElement("div", null,
                                        React.createElement("div", null,
                                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm &&
                                                    this.state.isActiveEditForm, className: "phone-ext--phone", leftItem: React.createElement(icons_1.PhoneIcon, null), missing: isError, label: "Phone *", onChange: this.handleChangeString("phone"), value: DataVal })),
                                        React.createElement("div", null,
                                            React.createElement("p", { style: { color: 'red' } }, isError))),
                                    React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm &&
                                            this.state.isActiveEditForm, className: "phone-ext--ext", label: "Ext", onChange: this.handleChangeString("phoneExt"), value: site.phoneExt || "" })))),
                        React.createElement("div", { className: "row", style: { display: 'inline-block' } },
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm, label: "Fax", leftItem: React.createElement(icons_1.FaxIcon, null), onChange: this.handleChangeString("fax"), missing: isErrorFax, value: DataValFax }),
                            React.createElement("div", null,
                                React.createElement("p", { style: { color: 'red', fontSize: 'x-small' } }, isErrorFax))),
                        React.createElement("div", { className: "row" },
                            !isClinicUser ? (React.createElement(select_1.MaterialSelect, { disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !canEdit, label: "Timezone *", missing: this.missing.timezone, className: "timezone", options: timezones, searchable: true, onSelect: this.handleChangeTimezone, value: site.timezone })) : null,
                            React.createElement(select_1.MaterialSelect
                            // disabled={!canEdit}
                            , { 
                                // disabled={!canEdit}
                                disabled: this.state.isActiveEditForm, label: "Physician In Charge", className: "pic", options: this.picOptions, onSelect: this.handleChangePIC, searchable: true, value: site.picProviderId ? site.picProviderId.toString() : "" })),
                        !isClinicUser ? (React.createElement("div", { className: "row" },
                            React.createElement(select_1.MaterialSelect, { disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !canEdit, label: "Dispense As Written Code *", 
                                // missing={this.missing.typeDAW}
                                className: "timezone", options: typeDAW, searchable: false, onSelect: this.handleChangeTypeDAW, value: site.typeDAW.toString() }))) : null,
                        !isClinicUser ? (React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm, className: "price", label: "Min Profit", numType: "price", placeholder: "10.00", type: "text", leftItem: React.createElement(icons_1.DollarsIcon, null), onChange: this.handleChangeNumber("minProfit"), value: site.minProfit || "" }),
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm, className: "price", label: "Max Copay", numType: "price", placeholder: "10.00", type: "text", leftItem: React.createElement(icons_1.DollarsIcon, null), onChange: this.handleChangeNumber("maxCopay"), value: site.maxCopay || "" }))) : null,
                        !isClinicUser ? (React.createElement("div", { className: "row" },
                            React.createElement(select_1.MaterialSelect, { disabled: this.state.isActiveEditForm, className: "imbfee-select", onSelect: this.handleChangeFeeType, options: [
                                    {
                                        id: 1,
                                        label: "Percentage",
                                        value: site_1.FeeType.Percent
                                    },
                                    {
                                        id: 2,
                                        label: "Flat Rate",
                                        value: site_1.FeeType.FlatRate
                                    }
                                ], label: "Service Fee Type", value: site.feeType || "", required: true }),
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm, className: "imbfee", label: `Service Fee ${site.feeType === site_1.FeeType.Percent ? "%" : "$"}`, missing: this.missing.imbFee, onChange: this.handleChangeNumber("imbFee"), numType: "price", type: "text", value: site.imbFee || site.imbFee === 0 ? site.imbFee : "", leftItem: site.feeType === site_1.FeeType.Percent ? (React.createElement("span", { style: {
                                        fontSize: 18,
                                        fontWeight: "bolder",
                                        paddingLeft: "4px"
                                    } }, "%")) : (React.createElement(icons_1.DollarsIcon, null)), required: true }),
                            site.feeType === site_1.FeeType.Percent ? (React.createElement(text_field_1.MaterialTextField, { className: "startbalance", label: "Starting Balance *", onChange: this.handleChangeNumber("startBalance"), type: "text", disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !!this.site.id, value: site.startBalance || site.startBalance === 0
                                    ? site.startBalance
                                    : "" })) : (React.createElement(React.Fragment, null)))) : null,
                        !isClinicUser ? (React.createElement("div", { className: "row" }, site.feeType === site_1.FeeType.FlatRate ? (React.createElement(React.Fragment, null,
                            React.createElement(text_field_1.MaterialTextField, { className: "imbfee", label: "Transaction Fee", onChange: this.handleChangeNumber("transactionFee"), value: site.transactionFee || "", type: "text", leftItem: React.createElement(icons_1.DollarsIcon, null), required: true }),
                            React.createElement(text_field_1.MaterialTextField, { className: "startbalance", label: "Starting Balance *", onChange: this.handleChangeNumber("startBalance"), type: "text", disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !!this.site.id, value: site.startBalance || "" }))) : (React.createElement(React.Fragment, null)))) : null,
                        userCanView ? (React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm, className: "site-website", label: "Clinic Website", onChange: this.handleChangeString("website"), value: site.website || "" }))) : null,
                        React.createElement("div", { className: "row" },
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm, className: "site-website", label: "Tax ID *", missing: this.missing.taxId, inputProps: { maxLength: 9 }, onChange: e => this.handleTaxIdChange(e), value: site.taxId || "" }))),
                    this.isAddPharmacy == 0 ? ("") : store_5.usersStore.permissions.UpdatePharmacy ? (React.createElement("div", null,
                        React.createElement(material_ui_1.Button, { className: "cstm-edit-btn", "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: this.handleClick },
                            React.createElement(material_ui_icons_1.MoreVert, null)),
                        React.createElement(material_ui_1.Menu, { id: "edit-menu", anchorEl: this.state.anchorEl, keepMounted: false, open: Boolean(this.state.anchorEl), onClose: this.handleClose },
                            React.createElement(material_ui_1.MenuItem, { onClick: this.handleEditDetails },
                                React.createElement(material_ui_icons_1.Edit, { style: { marginRight: 15 } }),
                                " Details"),
                            React.createElement(material_ui_1.MenuItem, { onClick: this.viewSiteAssets },
                                React.createElement(material_ui_icons_1.Edit, null),
                                " Assets")),
                        !this.state.isActiveEditForm && (React.createElement(material_ui_1.Button, { variant: "flat", color: "secondary", onClick: this.disableEditUserForm },
                            React.createElement(material_ui_icons_1.Edit, null),
                            "\u00A0 Disable")))) : (""),
                    !isClinicUser ? (
                    // ( C-089 cstm-account-info)  30-07-2024
                    React.createElement("div", { className: "account-info cstm-account-info" },
                        React.createElement("h3", null, "ACCOUNT STATUS"),
                        !this.state.isActiveEditForm && this.renderCheckboxGroup(),
                        userCanView ? (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            React.createElement("h3", null, "CLINIC LINK"),
                            site.website ? (React.createElement("a", { className: "site-website-link", href: this.siteWebsiteUrl
                                    ? this.siteWebsiteUrl.href
                                    : site.website, target: "__blank" }, this.getWebsiteUrl() || "")) : null)) : null,
                        React.createElement("div", { className: "view-assets" }, store_5.usersStore.permissions.ReadPharmacyAssets ? (React.createElement(asset_list_overview_1.AssetListOverview, { btnLabel: "Edit Asset", onClick: this.viewSiteAssets }, this.renderSiteAssetListRow())) : null))) : null),
                React.createElement("div", { className: "license-info" },
                    React.createElement("h3", null, "LICENSE INFO"),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "width-fix", style: { display: "flex", flexDirection: "column" } },
                            React.createElement(text_field_1.MaterialTextField
                            // disabled={!canEdit}
                            , { 
                                // disabled={!canEdit}
                                disabled: this.state.isActiveEditForm, className: "dea", label: "DEA License", missing: this.missing.deaLicense, onChange: this.handleChangeString("deaLicense"), value: site.deaLicense || "" }),
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !canEdit, label: "NCPDP # *", missing: this.missing.ncpdpId, onChange: this.handleChangeString("ncpdpId"), value: site.ncpdpId || "" }),
                            React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm
                                    ? this.state.isActiveEditForm
                                    : !canEdit, label: "NPI Number *", missing: this.missing.npiNumber, onChange: this.handleChangeString("npiNumber"), value: site.npiNumber || "" }),
                            site.picProvider ? (React.createElement(text_field_1.MaterialTextField, { disabled: this.state.isActiveEditForm, label: "PIC State License", value: (_a = site.picProvider.stateLicense) !== null && _a !== void 0 ? _a : "" })) : null),
                        React.createElement("div", null,
                            React.createElement("h3", { style: { textAlign: "initial" } }, "OFFICE HOURS"),
                            React.createElement(clinic_hours_1.ClinicHours, { clinicHours: this.site.clinicHours, onChange: this.handleClinicHoursChange, onChangeToggle: this.handleClinicHoursToggle, isDisabled: this.state.isActiveEditForm })))),
                React.createElement("div", { className: "notes-section" },
                    React.createElement("h3", { style: { marginRight: "3em" } }, "COPAY CARDS"),
                    React.createElement("div", { className: "cstm-table-outer" },
                        this.renderInsurance(),
                        this.confirmDeleteInsuranceModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Delete Copay", cancelText: "Cancel", message: `Please confirm. <br />Do you want to delete this copay card from the pharmacy?`, onCancel: () => {
                                this.confirmDeleteInsuranceModal = false;
                            }, onConfirm: this.handleDeleteInsurance, title: "Insurance Request" })),
                        React.createElement(button_1.MaterialButton, { disabled: this.state.isActiveEditForm, key: "submit", primary: true, onClick: () => {
                                this.editInsurance = true;
                            }, style: { marginLeft: "2em" } }, "Add Card"))),
                !isClinicUser ? (React.createElement("div", { className: "notes-section" },
                    React.createElement("h3", null, "NOTES"),
                    React.createElement("div", { className: "row" },
                        React.createElement(text_area_1.MaterialTextArea
                        // disabled={!canEdit} // Doesn't exist on this obj.
                        , { 
                            // disabled={!canEdit} // Doesn't exist on this obj.
                            disabled: this.state.isActiveEditForm, className: "textarea", value: (_b = site.notes) !== null && _b !== void 0 ? _b : "", onChange: this.handleChangeString("notes"), placeholder: "Notes" })))) : null,
                !this.site.id ? (React.createElement("div", { className: "notes-section" },
                    React.createElement("h3", null, "ENROLLMENT"),
                    React.createElement("div", { className: "row" },
                        React.createElement(switch_1.MaterialSwitch, { label: "Send enrollment email to ERX", value: "enrollment", checked: this.enrollment, onChange: this.toggleEnrollment })))) : null),
            this.showSupportingDocumentModal && (React.createElement(supporting_document_modal_1.SupportingDocumentModal, { fromTos: this.getFromTos(), handleAttachDoc: this.handleAttachDoc, handleCancel: () => {
                    this.showSupportingDocumentModal = false;
                    this.resetSupportingDocumentGroup();
                }, supportingDocumentGroup: this.supportingDocumentGroup, buttons: [
                    React.createElement(button_1.MaterialButton, { key: "submit", primary: true, onClick: this.handleSubmitClinicUserUpdateRequest }, "Submit Update Request")
                ] })),
            this.uploadSupportingDocumentModal && (React.createElement(upload_modal_1.UploadModal, { onCancel: () => {
                    this.uploadSupportingDocumentModal = false;
                }, message: `Please select supporting document files for ${site.displayName}.`, title: "Upload Supporting Documents", onDrop: this.handleSupportingDocumentUpload })),
            this.state.modelOpen && (React.createElement(modal_1.AssetModal, { title: `Are you sure you would like to edit?`, top: "200px", padding: "20px", onCancel: () => {
                    this.setState({ modelOpen: false });
                } },
                React.createElement("div", { style: { display: "flex", justifyContent: "center", padding: 15 } },
                    React.createElement(button_1.MaterialButton, { key: "submit", primary: true, onClick: this.handleEditUser, style: { marginLeft: "2em" } }, "Yes"),
                    React.createElement(material_ui_1.Button, { style: { background: "red", marginLeft: 5, color: "#fff" }, onClick: this.disableEditDetails }, "No")))),
            this.assetModal ? (React.createElement(modal_1.AssetModal, { title: `Assets For ${site.displayName}`, width: "unset", maxWidth: "55%", maxHeight: "70%", top: "100px", onCancel: () => {
                    this.assetModal = !this.assetModal;
                } },
                React.createElement(asset_list_1.AssetList, { uploads: site.uploads, entityType: "site", entityData: site, onCredentialUpload: this.onCredentialUpload, onDeleteUpload: this.onDeleteAsset, onImageUpload: this.onImageUpload, onDescriptionSave: this.handleAssetsDescriptionsSave, onExpDateSave: this.handleAssetsExpDateSave, onConnectAssetSave: this.handleAssetsDescriptionsSave, onCancel: () => {
                        this.assetModal = !this.assetModal;
                    } }))) : null,
            this.iframeUrl ? (React.createElement(iframe_preview_1.IFramePreview, { title: this.currentAssetViewing.fileOriginalName || "N/A", iframeUrl: this.iframeUrl, download: this.iframeUrl, onClose: this.handlePreviewClose })) : null,
            React.createElement(ReactTooltip, { effect: "solid", place: "left", delayShow: 300, "data-type": "info", multiline: true }),
            this.uploadModal && (React.createElement(upload_modal_1.UploadModal, { onCancel: this.handleClickCancelUpload, message: `Please select files for ${site.displayName}.`, title: "Upload Asset", onDrop: this.handleAssetsUpload })),
            this.editInsurance && this.editInsuranceModal()));
    }
};
__decorate([
    mobx_1.observable
], EditSite.prototype, "permissions", void 0);
__decorate([
    mobx_1.computed
], EditSite.prototype, "picOptions", null);
__decorate([
    mobx_1.observable
], EditSite.prototype, "checkboxSelections", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "site", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "missing", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "assetModal", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "copays", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "confirmDeleteInsuranceModal", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "clinicHoursHasChanged", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "currentAssetViewing", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "disableSave", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "editInsurance", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "enrollment", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "highLevelTitles", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "iframeUrl", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "inventories", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "insurance", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "justSaved", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "showSupportingDocumentModal", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "siteWebsiteUrl", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "supportingDocumentGroupName", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "uploadModal", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "uploadSupportingDocumentModal", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "uploadType", void 0);
__decorate([
    mobx_1.observable
], EditSite.prototype, "supportingDocumentGroup", void 0);
__decorate([
    mobx_1.computed
], EditSite.prototype, "availableInventory", null);
EditSite = __decorate([
    mobx_react_1.observer
], EditSite);
exports.EditSite = EditSite;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-site/edit-site.tsx
// module id = 4018
// module chunks = 0